export default [
    {
        name: 'emotion_angry',
        type: 'texture',
        path: 'textures/emojis/angry.png'
    },
    {
        name: 'emotion_awe',
        type: 'texture',
        path: 'textures/emojis/awe.png'
    },
    {
        name: 'emotion_blink',
        type: 'texture',
        path: 'textures/emojis/blink.png'
    },
    {
        name: 'emotion_dead',
        type: 'texture',
        path: 'textures/emojis/dead.png'
    },
    {
        name: 'emotion_dead_inside',
        type: 'texture',
        path: 'textures/emojis/dead_inside.png'
    },
    {
        name: 'emotion_energy',
        type: 'texture',
        path: 'textures/emojis/energy.png'
    },
    {
        name: 'emotion_full',
        type: 'texture',
        path: 'textures/emojis/full.png'
    },
    {
        name: 'emotion_happy',
        type: 'texture',
        path: 'textures/emojis/happy.png'
    },
    {
        name: 'emotion_love',
        type: 'texture',
        path: 'textures/emojis/love.png'
    },
    {
        name: 'emotion_no_energy',
        type: 'texture',
        path: 'textures/emojis/no_energy.png'
    },
    {
        name: 'emotion_normal',
        type: 'texture',
        path: 'textures/emojis/normal.png'
    },
    {
        name: 'emotion_sad',
        type: 'texture',
        path: 'textures/emojis/sad.png'
    },
    // {
    //     name: 'emotion_sad_little',
    //     type: 'texture',
    //     path: 'textures/emojis/sad_little.png'
    // },
    {
        name: 'emotion_tickle',
        type: 'texture',
        path: 'textures/emojis/tickle.png'
    },
    {
        name: 'emotion_what',
        type: 'texture',
        path: 'textures/emojis/what.png'
    },
    {
        name: 'emotion_wtf',
        type: 'texture',
        path: 'textures/emojis/wtf.png'
    },
    {
        name: 'environmentMap',
        type: 'texture',
        path: 'textures/environmentMap/panorama.jpg'
    },
    {
        name: 'tamagochi',
        type: 'texture',
        path: 'textures/tamagochi_device.png'
    }
]